// src/admin/DataMigration/utils/migrationHelpers.js

// Chuẩn hóa chuỗi (chữ thường, xóa dấu cách thừa, Unicode NFC)
export const normalizeStr = (str) => {
  if (!str) return '';
  return str.toString().normalize('NFC').toLowerCase().trim().replace(/\s+/g, ' ');
};

export const getStudentKey = (holyName, fullName) => {
  const normHoly = normalizeStr(holyName);
  const normFull = normalizeStr(fullName);
  return `${normHoly}_${normFull}`;
};

export const cleanDate = (val) => {
  if (!val || typeof val !== 'string') return '';
  let str = val.trim();
  if (['x', 'none', 'null', '-'].includes(str.toLowerCase())) return '';

  str = str.replace(/[.,-]/g, '/').replace(/\s*\/\s*/g, '/');
  const parts = str.split('/');
  if (parts.length === 3) {
    let [d, m, y] = parts.map(p => p.trim());
    if (y.length === 2) y = '20' + y;
    return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
  } else if (parts.length === 2) {
    let [m, y] = parts.map(p => p.trim());
    if (y.length === 2) y = '20' + y;
    return `${m.padStart(2, '0')}/${y}`;
  }
  return str;
};

export const cleanPhone = (val) => {
  if (!val) return '';
  const digits = val.toString().replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 9) return '0' + digits;
  return digits;
};

export const parseCSV = (text) => {
  const lines = [];
  let row = [];
  let entry = '';
  let inQuotes = false;
  const delimiter = text.includes(';') ? ';' : ',';

  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    const nextC = text[i + 1];

    if (c === '"') {
      if (inQuotes && nextC === '"') {
        entry += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (c === delimiter && !inQuotes) {
      row.push(entry.trim());
      entry = '';
    } else if ((c === '\r' || c === '\n') && !inQuotes) {
      if (c === '\r' && nextC === '\n') i++;
      row.push(entry.trim());
      if (row.some(cell => cell.length > 0)) lines.push(row);
      row = [];
      entry = '';
    } else {
      entry += c;
    }
  }
  if (entry || row.length > 0) {
    row.push(entry.trim());
    if (row.some(cell => cell.length > 0)) lines.push(row);
  }
  return lines;
};

// Loại bỏ dấu tiếng Việt để lấy chữ cái viết tắt
export const removeVietnameseTones = (str) => {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
};

// Lấy chữ cái đầu của Tên Thánh (Ví dụ: Giuse -> G, Têrêsa -> T)
export const getHolyNameFirstLetter = (holyName) => {
  if (!holyName) return 'X';
  const clean = removeVietnameseTones(holyName.trim());
  const letter = clean.charAt(0).toUpperCase();
  return letter.replace(/[^A-Z0-9]/g, '') || 'X';
};

// Lấy các chữ cái đầu của Họ và Tên (Ví dụ: Nguyễn Văn An -> NVA)
export const getFullNameInitials = (fullName) => {
  if (!fullName) return 'GLV';
  const clean = removeVietnameseTones(fullName.trim());
  const words = clean.split(/\s+/).filter(Boolean);
  const initials = words.map(w => w.charAt(0).toUpperCase()).join('');
  return initials.replace(/[^A-Z0-9]/g, '') || 'GLV';
};

/**
 * Sinh ID mới dạng liền: Số + Chữ đầu Tên Thánh + Chữ đầu Họ Tên
 * Ví dụ: 01GNVA, 02TTM (Không có khoảng trắng và không có gạch ngang)
 */
export const generateCatechistId = (index, holyName, fullName, padZero = true) => {
  const numberStr = padZero ? String(index).padStart(2, '0') : String(index);
  const holyInitial = getHolyNameFirstLetter(holyName);
  const nameInitials = getFullNameInitials(fullName);
  return `${numberStr}${holyInitial}${nameInitials}`;
};